module.exports = __webpack_public_path__ + "img/logo_sfags.50d84f7f.png";